import { Flex } from '@chakra-ui/react';
import {
  Card,
  CardBody,
  CardHeader,
  Checkbox,
  Heading,
  Paragraph,
} from 'ui-components';
import { convertPxToRems } from '~/utils-ts';

import { getReadableMetricValue } from './utils';

export interface MetricCardProps {
  isDisabled?: boolean;
  isChecked?: boolean;
  onChange?: (v: boolean) => void;
  metricTitle: string;
  metricSubtitle?: string;
  metricValue: number | string | undefined;
  metricTransformValue?: 'percentage' | 'number' | 'string';
}

export const MetricCard: React.FC<MetricCardProps> = ({
  metricTitle,
  metricSubtitle,
  metricValue,
  isDisabled = false,
  isChecked = undefined, // TODO: consider creating a new component `SelectableMetricCard` instead
  onChange,
  metricTransformValue = 'number',
}) => {
  return (
    <Card
      minWidth={convertPxToRems(300)}
      padding="14px 24px"
      borderColor={isChecked ? 'secondary.400' : 'primary.100'}
      _hover={{
        cursor: 'pointer',
        borderColor: isChecked ? 'secondary.400' : 'primary.100',
      }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      as={typeof isChecked === 'boolean' ? 'label' : undefined}
      pointerEvents={typeof isChecked === 'boolean' ? 'auto' : 'none'}
    >
      <CardHeader>
        <Flex justify="space-between">
          <Paragraph
            size="lg"
            data-testid="metric-title"
            color={isDisabled ? 'primary.200' : 'primary.400'}
            fontWeight="medium"
          >
            {metricTitle}
          </Paragraph>

          {typeof isChecked === 'boolean' ? (
            <Checkbox
              isChecked={isChecked}
              onChange={onChange}
              isDisabled={isDisabled}
            />
          ) : null}
        </Flex>
        {metricSubtitle ? (
          <Paragraph
            data-testid="metric-subtitle"
            size="sm"
            color={isDisabled ? 'primary.200' : 'primary.400'}
            fontWeight="normal"
            aria-disabled={isDisabled}
          >
            {metricSubtitle}
          </Paragraph>
        ) : null}
      </CardHeader>
      <CardBody>
        <Heading
          size="lg"
          color={isDisabled ? 'primary.300' : 'primary.700'}
          data-testid="metric-value"
        >
          {getReadableMetricValue(metricValue, metricTransformValue)}
        </Heading>
      </CardBody>
    </Card>
  );
};
